export const _setCurrentParameterId = (_currentParameterId: string) => {
  return {
    type: "SET_CURRENT_PARAMETER_ID",
    _currentParameterId,
  };
};

export const _setLanguageClick = (languageKey: string) => {
  return {
    type: "SET_LANGUAGE_CLICK",
    languageKey
  }
}

export const _setExternalSourceIframeOpen = (status: boolean) => {
  return {
    type: "UPDATE_EXTERNAL_SOURCE_IFRAME_OPEN",
    status,
  };
};